import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
// import DevTools from "mobx-react-devtools";

import ReactMapboxGl, {
  Layer,
  Feature,
  Popup,
  ZoomControl,
} from 'react-mapbox-gl';
// import MapboxCSS from "react-mapbox-gl/dist/mapbox-css/mapbox-gl.css"

import GlobeView from './GlobeView';
import uiState from './state/uiState';

const MAPBOX_KEY =
  'pk.eyJ1IjoibW9yaXR6c3RlZmFuZXIiLCJhIjoiUGs4LU1VZyJ9.oJh_Gi3geralmUvrJVWYaA';

const Map = ReactMapboxGl({
  accessToken: MAPBOX_KEY,
  dragPan: false,
  interactive: false,
});

@observer
class TimerView extends Component {
  render() {
    const { solPos, zoom, placeString, lat, lon } = uiState;

    // zoom in and out every 12 minutes

    return (
      <div>
        <Map
          style="mapbox://styles/mapbox/satellite-v9"
          // style="https://api.maptiler.com/maps/fcf29a74-121d-4fcf-b6c6-2e06e6b9153f/style.json?key=z2enoCfP6oRKlDTu6XPC"
          center={solPos}
          zoom={[zoom]}
          // accessToken={accessToken}
          bearing={0}
          movingMethod="flyTo" // "flyTo"
          flyToOptions={{
            speed: 0.01,
            // easing(t) {
            //   return t;
            // },
          }}
          containerStyle={{
            width: '100vw',
            height: '100vh',
            position: 'absolute',
          }}
        />
        <div className="sun" />
        <div className="text">
          <h1>Under the sun</h1>

          <div className="numbers">
            <div>
              <div className="date">{uiState.dateString}</div>
              <div className="time">
                <span className="hours">{twoDigits(uiState.hours)}</span>
                <span className="separator" />
                <span className="minutes">{twoDigits(uiState.minutes)}</span>
                <span className="separator" />
                <span className="seconds">{twoDigits(uiState.seconds)}</span>
              </div>

              <div className="coords">
                The sun is at zenith at {lat.toFixed(3)}, {lon.toFixed(3)}
              </div>
              {/* <div className="zoom">{zoom.toFixed(3)}</div> */}
              <div className="place">{placeString}</div>
            </div>
          </div>

          <div className="globe">
            <GlobeView center={solPos} />
          </div>
        </div>
      </div>
    );
  }
}

function twoDigits(n) {
  if (n < 10) n = `0${n}`;
  return n;
}

export default TimerView;
